<!--
    Summary:
        我的
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-card">
    <div class="v-card-main" :class="[ hasImg ? 'avg' : '' ]">
      <div class="v-card-content-wrapper">
        <div class="v-card-title">
          <h2>
            <slot name="title"></slot>
          </h2>
          <div class="subtitle">
            <slot name="subtitle"></slot>
          </div>
          <div class="v-card-short-line"></div>
        </div>
        <div class="v-card-content">
          <slot></slot>
        </div>
      </div>
      <div class="v-card-img-wrapper" v-if="hasImg">
        <slot name="img"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:"img-card",
    props: {
      hasImg: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-card {
    width: 100%;
    text-align: left;

    .v-card-main {
      padding-top: 60px;
      padding-bottom: 30px;
      width: 1200px;
      margin: 0 auto;

      display: flex;

      &.avg > div {
        width: 50% !important;
      }

      .v-card-content-wrapper {
        width: 100%;
        .v-card-title {
          width: 100%;
          h2 {
            color: #e699b2;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            text-transform: none;
            letter-spacing: 1px;
            margin: 0;
            line-height: 1.384615384615385em;
          }

          .subtitle {
            color: #3a3a3a;
            font-size: 14px;
            line-height: 24px;
            font-style: normal;
            font-weight: 400;
          }

          .v-card-short-line {
            margin: 10px 0 30px;
            background-color: #e699b2;
            width: 250px;
            height: 2px;
            position: relative;
            display: block;
          }
        }

        .v-card-content {
          width: 100%;
          p {
            color: #3a3a3a;
            font-size: 16px;
            line-height: 24px;
            font-style: normal;
            font-weight: 400;
            margin: 0;
            letter-spacing: 1px;
          }
        }
      }

      .v-card-img-wrapper {
        padding: 0 15px;

        img {
          width: 100%;
        }

      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/view/genedetection/img-card.vue